import { useAuthentication } from 'src/features/authentication/context';
import { Protected } from 'src/features/protected-route/components';
import { ACCOUNT_ISSUE_PATH, ADD_SITES_HEADER, LOGIN_PATH } from '../../config';
import { AppLayout } from 'src/layouts';
import {
  NAV_ITEMS_HEADER_SITES_MANAGEMENT,
  getNavItemsHeaderSiutesManagementSAAndAA,
} from 'src/features';
import { AddSitePage } from '../../pages';
import { ElementProps } from '../../types/element';
import { LoadingElement } from '../LoadingElement';
import { AccessRoles } from 'src/features/user-account-details/types';

export const SiteAddElement = ({ isSuperAdmin }: ElementProps) => {
  const { isCustomerAccessAllowed, loggedIn, customerId, getCurrentRole, user } =
    useAuthentication();
  const isAccountAdmin = getCurrentRole(customerId.value, null) === AccessRoles.ACCOUNT_ADMIN;

  const getUniqueRedirectPath = () => {
    if (!loggedIn.value) return LOGIN_PATH;
    if (!isSuperAdmin && (!isAccountAdmin || !isCustomerAccessAllowed.value))
      return ACCOUNT_ISSUE_PATH + '?reason=Access Denied';
  };

  const SiteAddRouteElement = () => (
    <Protected
      isAuthenticated={loggedIn.value}
      isAuthorized={isSuperAdmin || (isAccountAdmin && isCustomerAccessAllowed.value)}
      uniqueRedirectPath={getUniqueRedirectPath()}
    >
      <AppLayout
        headerTitle={ADD_SITES_HEADER}
        headerNavItems={
          isSuperAdmin || isAccountAdmin
            ? getNavItemsHeaderSiutesManagementSAAndAA(user, isSuperAdmin)
            : NAV_ITEMS_HEADER_SITES_MANAGEMENT
        }
      >
        <AddSitePage />
      </AppLayout>
    </Protected>
  );

  const getSiteAddElement = () => {
    if (isSuperAdmin && loggedIn.loaded) return <SiteAddRouteElement />;

    if (!loggedIn.loaded) return <LoadingElement />;

    if (loggedIn.loaded && !loggedIn.value) return <SiteAddRouteElement />;

    if (!customerId.value || !customerId.loaded) return <LoadingElement />;

    if (!isCustomerAccessAllowed.loaded) return <LoadingElement />;

    return <SiteAddRouteElement />;
  };

  return getSiteAddElement();
};
